module.exports = __webpack_public_path__ + "static/media/instagram.60eb6c8e.png";